import type { FC, ReactNode } from 'react'

import { SPARKLE_PATH } from '@/components/landing/decor/sparkle'

interface GeoGroundProps {
    className?: string
}

const PLUSES = [
    { x: 150, y: 120 },
    { x: 610, y: 96 },
    { x: 980, y: 132 },
    { x: 1390, y: 104 }
]

// The ground under the chapter scene as layered geometry: terraced strata in paper tones,
// contour lines, outlines of column stubs, a broken arch, steps and a fallen observation dish,
// with + and ✦ marks. The Mahonia confusa symbols are placed on top of it.
const GeoGround: FC<GeoGroundProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 1600 300' preserveAspectRatio='xMidYMax slice' aria-hidden='true' focusable='false' className={className}>
            <g fill='none' stroke='#1d2a33' strokeOpacity='0.1'>
                <path d='M0 170C260 150 520 186 800 164C1080 142 1340 176 1600 158' strokeDasharray='3 8' />
                <path d='M0 196C280 178 540 210 820 190C1100 170 1350 202 1600 186' />
            </g>

            <path d='M0 220H180V204H340V214H520V196H700V210H880V198H1080V214H1260V200H1440V212H1600V300H0Z' fill='#ebe5d8' stroke='#1d2a33' strokeOpacity='0.14' />
            <path d='M0 246H240V234H420V244H640V228H860V240H1040V230H1240V244H1420V234H1600V300H0Z' fill='#f2ede2' stroke='#1d2a33' strokeOpacity='0.18' />
            <path d='M0 276H1600V300H0Z' fill='#f8f5ee' />

            <g fill='#fdfcf8' stroke='#1d2a33' strokeOpacity='0.26' strokeWidth='1.2'>
                <path d='M96 246V150H134V246Z' />
                <path d='M90 150H140V138H90Z' />
                <path d='M232 234V176A52 52 0 0 1 336 176V190H316V180A32 32 0 0 0 252 180V234Z' />
                <path d='M470 244V214H540V244ZM540 244V228H596V244Z' />
                <path d='M760 240L790 196L860 226L842 240Z' />
                <path d='M1056 230V126H1088V230Z' />
                <path d='M1050 126H1094V116H1050Z' />
                <path d='M1180 244A70 34 0 0 1 1310 214' />
                <path d='M1245 229L1290 186M1290 186L1300 176' />
                <path d='M1460 234V168H1520V234Z' />
            </g>
            <g fill='none' stroke='#1d2a33' strokeOpacity='0.16'>
                <path d='M106 160V240M115 160V240M124 160V240' />
                <path d='M1066 136V224M1078 136V224' />
                <path d='M1470 184H1510M1470 200H1510M1470 216H1510' strokeDasharray='3 4' />
            </g>

            <g stroke='#1d2a33' strokeOpacity='0.3' strokeWidth='1.2'>
                {PLUSES.map(item => (
                    <path key={`${item.x}-${item.y}`} d={`M${item.x - 6} ${item.y}H${item.x + 6}M${item.x} ${item.y - 6}V${item.y + 6}`} />
                ))}
            </g>
            <path d={SPARKLE_PATH} fill='#e2b33c' transform='translate(392 112) scale(0.62)' />
            <path d={SPARKLE_PATH} fill='#e2b33c' transform='translate(1188 96) scale(0.5)' />
        </svg>
    )
}

export default GeoGround
